<template>
    <section>
        Evidencias
    </section>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>